// keywordManagment

export interface Keyword
 {
  id   : number ,
  word : string
 }

export const initializedKeyword = (): Keyword => (
 {
  id   : 0  ,
  word : ""
});

